import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import i18n from 'i18n';
import useForm from 'hooks/useForm';
import getBasicDate from 'utils/dates/getBasicDate';
import { getZonedTodayDate, userLocalTimezone } from 'utils/timezone';
import getDateAndTimeInTimezone from 'utils/timezone/getDateAndTimeInTimezone';
import { DEFAULT_TIME } from 'utils/times/defaultTime';
import { addHoursToTime } from 'utils/times/addHoursToTime';
import { isStartTimeBeforeEndTime } from './endTimeValidation';
export function useSessionForm(_ref) {
  var _session$startDateTim, _session$endDateTime;
  var session = _ref.session;
  var sessionStartDateTime = (_session$startDateTim = session === null || session === void 0 ? void 0 : session.startDateTime) !== null && _session$startDateTim !== void 0 ? _session$startDateTim : undefined;
  var sessionEndDateTime = (_session$endDateTime = session === null || session === void 0 ? void 0 : session.endDateTime) !== null && _session$endDateTime !== void 0 ? _session$endDateTime : undefined;
  var defaultTimezone = (session === null || session === void 0 ? void 0 : session.timezone) || userLocalTimezone;
  var _getDateAndTimeInTime = getDateAndTimeInTimezone({
      dateTime: sessionStartDateTime,
      timezone: defaultTimezone
    }),
    timezoneAdjustedDate = _getDateAndTimeInTime.date,
    timezoneAdjustedStartTime = _getDateAndTimeInTime.time;
  var _getDateAndTimeInTime2 = getDateAndTimeInTimezone({
      dateTime: sessionEndDateTime,
      timezone: defaultTimezone
    }),
    timezoneAdjustedEndTime = _getDateAndTimeInTime2.time;
  var defaultDate = timezoneAdjustedDate || getBasicDate(getZonedTodayDate(defaultTimezone));
  var defaultStartTime = timezoneAdjustedStartTime || DEFAULT_TIME;
  var defaultEndTime = timezoneAdjustedEndTime || addHoursToTime(defaultStartTime, 1) || DEFAULT_TIME;
  return useForm({
    fields: {
      date: {
        getDefaultValue: function getDefaultValue() {
          return defaultDate;
        },
        required: true
      },
      startTime: {
        getDefaultValue: function getDefaultValue() {
          return defaultStartTime;
        },
        required: true
      },
      endTime: {
        getDefaultValue: function getDefaultValue() {
          return defaultEndTime;
        },
        required: true,
        getError: function getError(value, _field, fieldStates) {
          var _fieldStates$startTim;
          if (!value) {
            return undefined;
          }
          var startTime = typeof ((_fieldStates$startTim = fieldStates.startTime) === null || _fieldStates$startTim === void 0 ? void 0 : _fieldStates$startTim.value) === 'string' ? fieldStates.startTime.value : '';
          return isStartTimeBeforeEndTime(startTime, value) ? undefined : i18n.t('error_end_time_after_start_time');
        }
      },
      timezone: {
        getDefaultValue: function getDefaultValue() {
          return defaultTimezone;
        },
        required: true
      },
      location: {
        getDefaultValue: function getDefaultValue() {
          return (session === null || session === void 0 ? void 0 : session.location) || '';
        },
        required: true
      },
      reference: {
        getDefaultValue: function getDefaultValue() {
          return (session === null || session === void 0 ? void 0 : session.reference) || '';
        }
      },
      capacity: {
        getDefaultValue: function getDefaultValue() {
          var _session$capacity;
          return (_session$capacity = session === null || session === void 0 ? void 0 : session.capacity) !== null && _session$capacity !== void 0 ? _session$capacity : null;
        }
      },
      linkUrl: {
        getDefaultValue: function getDefaultValue() {
          return (session === null || session === void 0 ? void 0 : session.linkUrl) || '';
        },
        getError: function getError(value) {
          if (!value) {
            return undefined;
          }
          try {
            new URL(value);
            return undefined;
          } catch (_unused) {
            return i18n.t('error_invalid_url');
          }
        }
      },
      facilitator: {
        getDefaultValue: function getDefaultValue() {
          return (session === null || session === void 0 ? void 0 : session.facilitator) || '';
        }
      },
      joiningInstructions: {
        getDefaultValue: function getDefaultValue() {
          return (session === null || session === void 0 ? void 0 : session.joiningInstructions) || '';
        }
      }
    }
  });
}
export default useSessionForm;